import { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      clipPath="url(#a)"
      fill="#EE6002"
      stroke="#EE6002"
      strokeWidth={0.3}
      strokeLinejoin="round"
    >
      <path d="M11.991 8.951c.407 0 .729.323.729.73v4.431l2.338-1.557v-.001a.727.727 0 0 1 .87 1.16.2.2 0 0 1-.044.052l-3.153 2.096v6.555c0 .407-.321.73-.728.73a.724.724 0 0 1-.73-.73v-8.87l-3.152-2.098a.727.727 0 0 1 .673-1.278l.13.067v.001l2.338 1.557V9.68c0-.407.322-.73.73-.73Z" />
      <path d="M12 .85c4.111 0 7.465 3.24 7.658 7.303a5.34 5.34 0 0 1 3.492 5.005 5.37 5.37 0 0 1-5.36 5.36h-2.316a.724.724 0 0 1-.729-.729c0-.407.322-.728.729-.729h2.315a3.91 3.91 0 0 0 3.903-3.902 3.89 3.89 0 0 0-2.922-3.78l-.029-.01-.025-.015-.006-.004-.015-.005-.058-.028-.073-.04c-.015-.01-.049-.032-.082-.06v.003c-.063-.043-.102-.105-.123-.135l-.01-.016-.017-.03-.028-.05v-.002a.35.35 0 0 1-.058-.137c-.029-.064-.027-.122-.027-.149v-.185c0-3.426-2.794-6.22-6.219-6.22S5.781 5.09 5.781 8.516V8.7a.2.2 0 0 1-.008.047.2.2 0 0 0-.014.058.2.2 0 0 1-.008.047 1 1 0 0 1-.048.115h.001a.4.4 0 0 1-.064.116v.001c-.02.03-.059.092-.122.135l-.001-.001-.045.033-.012.007-.023.018a.6.6 0 0 1-.133.067l-.017.011-.03.015-.028.006v.003a3.904 3.904 0 0 0 .982 7.683h2.315c.407 0 .729.321.729.728s-.322.73-.729.73H6.211a5.37 5.37 0 0 1-5.361-5.36 5.34 5.34 0 0 1 3.49-5.006C4.535 4.091 7.89.85 12 .85Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M24 0v24H0V0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;
